module.exports = __webpack_public_path__ + "static/media/logo.1ef5cba5.svg";